module.exports = __webpack_public_path__ + "static/iPhoneXS-Car-Noon.14dfb1c7.jpg";